import { AddNewImportSetField, AddNewImportSetProps } from "app/area/import-sets-administration/list/add-import-set/types";
import { ChangeOptionType } from "app/area/import-sets-administration/list/types";

export const hasFieldValueChanged = (prevProps: AddNewImportSetProps, props: AddNewImportSetProps) => {
  const previousForm = prevProps?.list?.addImportSet?.form ?? {};
  const currentForm = props?.list?.addImportSet?.form ?? {};

  return Object.keys(AddNewImportSetField)
    .some(field => currentForm[field] !== previousForm[field]);
};

export const emptyAddImportSet = (props: AddNewImportSetProps) => {
  const addImportSet = props?.list?.addImportSet?.form ?? {};

  return props.list.addImportSet.state === ChangeOptionType.Copy
    && (addImportSet[AddNewImportSetField.copyImportSet] || []).length === 0;
};
